import { z } from 'zod';
import { paginationSchema } from './common.js';
export const providerSlugSchema = z.enum(['openai', 'replicate']);
export const projectIdSchema = z
    .string()
    .trim()
    .regex(/^proj_[A-Za-z0-9_-]+$/, 'OpenAI project ID `proj_…` formatında olmalı')
    .max(128);
export const credentialCreateSchema = z.discriminatedUnion('providerSlug', [
    z.object({
        customerId: z.string().uuid(),
        providerSlug: z.literal('openai'),
        projectId: projectIdSchema,
        label: z.string().min(1).max(100),
        usageMultiplier: z.number().min(0.01).max(100).optional(),
    }),
    z.object({
        customerId: z.string().uuid(),
        providerSlug: z.literal('replicate'),
        apiKey: z.string().min(8).max(512),
        label: z.string().min(1).max(100),
        usageMultiplier: z.number().min(0.01).max(100).optional(),
    }),
]);
export const credentialUpdateMultiplierSchema = z.object({
    usageMultiplier: z.number().min(0.01).max(100),
});
export const credentialRotateSchema = z.union([
    z.object({ providerSlug: z.literal('openai'), newProjectId: projectIdSchema }),
    z.object({ providerSlug: z.literal('replicate'), newApiKey: z.string().min(8).max(512) }),
]);
export const credentialListQuerySchema = paginationSchema.extend({
    customerId: z.string().uuid().optional(),
});
